export default __webpack_public_path__ + "static/media/132039681_797217821003051_3852688437575950440_n.2ff8e31c.jpg";